"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpHandler = void 0;
const ethereum_utils_1 = require("@ganache/ethereum-utils");
// TODO: support http2
// Issue: https://github.com/trufflesuite/ganache/issues/3474
const http_1 = __importStar(require("http"));
const https_1 = __importStar(require("https"));
const base_handler_1 = require("./base-handler");
const deferred_1 = __importDefault(require("../deferred"));
const { JSONRPC_PREFIX } = base_handler_1.BaseHandler;
class HttpHandler extends base_handler_1.BaseHandler {
    constructor(options, abortSignal) {
        super(options, abortSignal);
        this.url = options.fork.url;
        this.headers.accept = this.headers["content-type"] = "application/json";
        if (this.url.protocol === "http:") {
            this._request = http_1.default.request;
            this.agent = new http_1.Agent({
                keepAlive: true,
                scheduling: "fifo"
            });
        }
        else {
            this._request = https_1.default.request;
            this.agent = new https_1.Agent({
                keepAlive: true,
                scheduling: "fifo"
            });
        }
    }
    async handleLengthedResponse(res, length) {
        return await new Promise((resolve, reject) => {
            const buffer = Buffer.allocUnsafe(length);
            let offset = 0;
            function data(message) {
                const messageLength = message.length;
                // note: Node will NOT send us more data than the content-length header
                // denotes, so we don't have to worry about it.
                message.copy(buffer, offset, 0, messageLength);
                offset += messageLength;
            }
            function end() {
                // note: Node doesn't check if the content-length matches (we might
                // receive less data than expected), so we do that here
                if (offset !== length) {
                    // if we didn't receive enough data, throw
                    reject(new Error("content-length mismatch"));
                }
                else {
                    resolve(buffer);
                }
            }
            res.on("data", data);
            res.on("end", end);
            res.on("error", reject);
        });
    }
    async handleChunkedResponse(res) {
        const chunks = [];
        let totalLength = 0;
        for await (let chunk of res) {
            chunks.push(chunk);
            totalLength += chunk.length;
        }
        return chunks.length === 1 ? chunks[0] : Buffer.concat(chunks, totalLength);
    }
    async request(method, params, options = { disableCache: false }) {
        const key = JSON.stringify({ method, params });
        const { protocol, hostname: host, port, pathname, search } = this.url;
        const requestOptions = {
            protocol,
            host,
            port,
            path: pathname + search,
            headers: this.headers,
            method: "POST",
            agent: this.agent,
            // Node v15 supports AbortSignals directly
            signal: this.abortSignal
        };
        const send = () => {
            if (this.abortSignal.aborted)
                return Promise.reject(new ethereum_utils_1.AbortError());
            const deferred = (0, deferred_1.default)();
            const postData = `${JSONRPC_PREFIX}${this.id++},${key.slice(1)}`;
            this.headers["content-length"] = postData.length;
            const req = this._request(requestOptions);
            req.on("response", res => {
                const { headers } = res;
                let buffer;
                // in the browser we can't detect if the response is compressed (gzip),
                // but it doesn't matter since the browser has decompressed already
                // anyway
                if (process.env.IS_BROWSER) {
                    buffer = this.handleChunkedResponse(res);
                }
                else {
                    // if we have a transfer-encoding we don't care about "content-length"
                    // (per HTTP spec). We also don't care about invalid lengths
                    if ("transfer-encoding" in headers) {
                        buffer = this.handleChunkedResponse(res);
                    }
                    else {
                        const length = headers["content-length"] / 1;
                        if (isNaN(length) || length <= 0) {
                            buffer = this.handleChunkedResponse(res);
                        }
                        else {
                            // we have a content-length; use it to pre-allocate the required memory
                            buffer = this.handleLengthedResponse(res, length);
                        }
                    }
                }
                // TODO: handle invalid JSON (throws on parse)?
                // Issue: https://github.com/trufflesuite/ganache/issues/3475
                buffer.then(buffer => {
                    try {
                        deferred.resolve({
                            response: JSON.parse(buffer),
                            raw: buffer
                        });
                    }
                    catch {
                        const resStr = buffer.toString();
                        let shortStr;
                        if (resStr.length > 340) {
                            // truncate long errors so we don't blow up the user's logs
                            shortStr = resStr.slice(0, 320) + "…";
                        }
                        else {
                            shortStr = resStr;
                        }
                        let msg = `Invalid JSON response from fork provider:\n\n ${shortStr}`;
                        if ((resStr.startsWith("invalid project id") ||
                            resStr.startsWith("project id required in the url")) &&
                            this.url.host.endsWith("infura.io")) {
                            msg += `\n\nThe provided fork url, ${this.url}, may be an invalid or incorrect Infura endpoint.`;
                            msg += `\nVisit https://infura.io/docs/ethereum for Infura documentation.`;
                        }
                        deferred.reject(new Error(msg));
                    }
                });
            });
            // after 5 seconds of idle abort the request
            req.setTimeout(5000, req.abort.bind(req, null));
            req.on("error", deferred.reject);
            req.write(postData);
            req.end();
            return deferred.promise.finally(() => this.requestCache.delete(key));
        };
        return await this.queueRequest(method, params, key, send, options);
    }
}
exports.HttpHandler = HttpHandler;
//# sourceMappingURL=http-handler.js.map